import React from "react";
import PropTypes from "prop-types";

import "./css/amountLineItem.css";

const AmountLineItem = ({ title, amount, customClass }) => (
  <div
    className={`amount__line__item ${customClass}`}
    data-quid={`amounts-${title}`}
  >
    <p
      className="amount__line__item__title"
      data-quid={`amounts-${title}-title`}
    >
      {title}:
    </p>
    <p
      className="amount__line__item__amount"
      data-quid={`amounts-${title}-amount`}
    >
      {amount}
    </p>
  </div>
);

AmountLineItem.propTypes = {
  title: PropTypes.string.isRequired,
  amount: PropTypes.string.isRequired,
  customClass: PropTypes.string
};

AmountLineItem.defaultProps = {
  customClass: ""
};

export default AmountLineItem;
